import "bootstrap/dist/css/bootstrap.min.css";

function htgt(props) {
  return (
    <div className="container">
      <h1 className="text-uppercase">HOW TO GROW A TREE</h1>
      <hr />
    </div>
  );
}
export default htgt;
